(function () {
  var params = new URLSearchParams(window.location.search);
  var sellingPlanId = params.get('selling_plan');
  var purchase = params.get('purchase');

  if (!sellingPlanId && purchase !== 'onetime') return;

  function escapeAttr(value) {
    return String(value).replace(/\\/g, '\\\\').replace(/"/g, '\\"');
  }

  function preselectPurchaseOption() {
    var widget = document.querySelector('[data-bsub-widget]');
    if (!widget) return;

    if (purchase === 'onetime' && !sellingPlanId) {
      var oneTime = widget.querySelector('[data-bsub-purchase-option-one-time]');
      if (oneTime) oneTime.checked = true;
      return;
    }

    var productJsonEl = widget.querySelector('[data-bsub-product-json]');
    if (!productJsonEl) return;

    var product;
    try {
      product = JSON.parse(productJsonEl.textContent);
    } catch (error) {
      return;
    }

    var matchedPlan = null;
    var matchedGroup = null;

    (product.selling_plan_groups || []).forEach(function (group) {
      (group.selling_plans || []).forEach(function (plan) {
        if (String(plan.id) === String(sellingPlanId)) {
          matchedPlan = plan;
          matchedGroup = group;
        }
      });
    });

    if (!matchedPlan || !matchedGroup) return;

    var groupInput = widget.querySelector(
      '[data-bsub-selling-plan-group-input][value="' + escapeAttr(matchedGroup.id) + '"]'
    );
    if (!groupInput) {
      groupInput = widget.querySelector(
        '[data-bsub-selling-plan-group-input]:not([data-bsub-purchase-option-one-time])'
      );
    }
    if (groupInput) groupInput.checked = true;

    var frequencyValue =
      (matchedPlan.options && matchedPlan.options[0] && matchedPlan.options[0].value) ||
      matchedPlan.name;
    if (!frequencyValue) return;

    var frequencyInput = widget.querySelector(
      '[data-bsub-delivery-frequency-option][value="' + escapeAttr(frequencyValue) + '"]'
    );
    if (frequencyInput) frequencyInput.checked = true;
  }

  document.addEventListener('DOMContentLoaded', preselectPurchaseOption);
})();
